import { Input } from "../lib/Input";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import SPGun from "./SPGun";
import SPPlayer from "./SPPlayer";
import SPRocketBehavior from "./SPRocketBehavior";

export default class SPRocketGun extends SPGun {
    constructor(player: SPPlayer) {
        super(player, {
            damage: 5,
            fireRate: 1,
            reloadTime: 6,
            bulletSpeed: 100,
            magSize: 6,
            mouseTrigger: 2,
            maxEnemiesHit: 1
        });
    }

    onShoot(): void {
        const centerSpawnPos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const velocity = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));
        const [, rocket] = this.player.engine.NewGameObjectWithScript<SPRocketBehavior>(SPRocketBehavior, {
            position: centerSpawnPos,
            initialValues: {
                velocity
            }
        });

        rocket.transform.rotation = this.player.transform.rotation.clone();
    }

    Shoot() {
        
        if (this.bullets === 0 || this.fireTimer > 0) return;
        
        this.bullets--;
        this.onShoot();
        this.fireTimer = 1/this.fireRate;
        if (this.reloadTimer === 0) this.reloadTimer = this.reloadTime;
        
    }

    Update(): void {
        if (this.player.isDead) return;

        if (this.fireTimer > 0) {
            this.fireTimer -= Time.deltaTime;

            if (this.fireTimer <= 0) this.fireTimer = 0;
        }

        if (this.mouseTrigger != undefined && Input.GetMouseButton(this.mouseTrigger)) {
            
            this.Shoot();
        }

        if (this.bullets < this.magSize && this.reloadTimer > 0) {
            this.reloadTimer -= Time.deltaTime;

            if (this.reloadTimer <= 0) {
                this.bullets++;

                if (this.bullets < this.magSize) {
                    this.reloadTimer = this.reloadTime;
                } else this.reloadTimer = 0;
            }
        }
    }

    Draw(yOffset: number): void {
        const ctx = this.player.ctx;
        const engine = this.player.engine;

        for (let i = 0; i < this.magSize; i++) {
            ctx.fillStyle = this.bullets > i ? '#ffffff' : '#ffffff55';
            engine.FillRect(this.player.transform.position.add(new Vector2(25 - 4 - 6*i, this.player.size + yOffset)), new Vector2(2, 4));
        }
    }
}